import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';
import { Apis } from '../../core/apis';
import { TokenAndRefreshToken } from '../../models/tokenandrefreshtoken.model';
import { LoginRequest } from '../../models/reqres/login.request';

const API_LOGIN_URL = Apis.userLogin;
const API_USER_ME_URL = Apis.getProfile;
const API_USER_TYPE_URL = Apis.getUserType;

@Injectable({
  providedIn: 'root',
})
export class LoginService implements OnDestroy {
  callbackResponseForUser = new Subject();

  constructor(private http: HttpClient) {}

  login(data: LoginRequest): Observable<TokenAndRefreshToken> {
    return this.http.post<TokenAndRefreshToken>(API_LOGIN_URL, data);
  }

  getProfile(): Observable<any> {
    return this.http.get<any>(API_USER_ME_URL);
  }

  getUserType() {
    return this.http.get<any>(API_USER_TYPE_URL);
  }

  updateUser(val: any) {
    this.callbackResponseForUser.next(val);
  }

  ngOnDestroy() {}
}
